module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "h2"
    }
  }), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }), _c('a', {
    attrs: {
      "id": "rpla_01"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Deborah")]), _vm._v(" in German hands in April 1918. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Jean Luc Caudron")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_02"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Germans inspecting the wreckage of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deborah")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Philippe Gorczynski")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_03"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willie Anthony and friends at Flesquières, 16 March 1919. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Anthony family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_04"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The same view today.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_05"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Uriah’s bus’. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Heap family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_06"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Burying of a tank’. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Tank Museum")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_07"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Lieutenant George Macdonald and brother officers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Catherine Piper")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_08"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial photo of battlefield after the attack of 22 August 1917. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photographs © Royal Museum of the Army and of Military History (Nr Inv KLM-MRA 201530003 & 20608-sintjuliaan)")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_09"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Lieutenant Frank Heap. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Heap family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boy soldiers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Heap family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunner George Foot. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Charles Foot")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunner Fred Tipping. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Mike Tipping")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunner William Galway. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Galway family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunner Joseph Cheverton. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from the Summers family")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheverton’s fiancée Florrie Coote. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Derek Leland")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lance-Corporal David ‘Bert’ Marsden. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from David Melliar-Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonel Christopher Baker-Carr. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Sue Peck")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lieutenant-Colonel William Kyngdon. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from")]), _vm._v(" Pemba, The Spice Island of Zanzibar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Captain John Craster")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major R.O.C. Ward. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Simon Ward")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Graeme Nixon and Lieutenant Alfred Enoch. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Russell Enoch")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lieutenant Enoch outside a captured German dugout. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Russell Enoch")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Officers from No. 12 Company. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Russell Enoch")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Macintosh. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from John Macintosh")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major William Watson. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from William Watson")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Major Watson’s officers at La Lovie. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Imperial War Museum (Q 2898)")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aerial photo of Flesquières. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from National Archives")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prisoners taken before Cambrai.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tanks from D and C Battalions on trains. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Imperial War Museum (detail from Q 46940)")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painting by Sergeant Claude Rowberry. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Royal Tank Regiment")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A German’s soldier’s view of the fighting at Flesquières.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postcard of the legendary lone gunner.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German artist’s impression of the battle at Flesquières.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Deborah")]), _vm._v(" emerges from the ground in November 1998. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Philippe Gorczynski")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Descendants of Deborah’s crew meet in 2009. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photograph from Press Association")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "rpla_35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/63_illus#pla_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deborah today. Photograph from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nord Tourisme")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2f1b94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_plates.vue
// module id = 72
// module chunks = 0